import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { DropDownList } from '@/components/dropDownList'

import { localized } from '@/decorators/localized'

@localized()
class PickValueDialog extends React.Component {
  state = {
    selectedValue: null
  }

  render () {
    const { data, dataSource, onAction, locale, ...props } = this.props
    const { selectedValue } = this.state
    return (
      <React.Fragment>
        <BasicHeader {...props} />
        <ModalBody>
          <ErrorBoundary>
            {typeof dataSource === 'function'
              ? (
                <DropDownList
                  dataSource={dataSource}
                  onChange={({ item }) => this.setState({ selectedValue: item })}
                  value={selectedValue} />
              ) : (
                <DropDownList data={data || []} value={selectedValue}
                  onChange={({ value }) => this.setState({ selectedValue: value })} />
              )
            }
          </ErrorBoundary>
        </ModalBody>
        <ConfirmFooter {...props} onAction={() => onAction(selectedValue)} disabled={!selectedValue} />
      </React.Fragment>
    )
  }
}

export {
  PickValueDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/common/pickValueDialog.js